import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import BasePopup from '@r1-frontend/ui-react/components/popups/basePopup';
import { List } from '@r1-frontend/ui-react/components/Channels/ChannelsList/styled';
import { ChannelsSelector } from '@r1-frontend/ui-react/components/Channels/ChannelsFilters/styled';

export const SBasePopup = styled(BasePopup)`
    padding-bottom: 12px !important;

    ${ChannelsSelector} {
        display: flex;
    }

    ${List} {
        display: flex;
        flex-wrap: wrap;
    }
`;

export const HideSearchBtn = styled(Button)`
    padding-left: 0;
    padding-top: 2px;
    padding-bottom: 3px;
`;
